var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11111 6.88889C7.11111 5.59227 7.62619 4.34877 8.54303 3.43192C9.45988 2.51508 10.7034 2 12 2C13.2966 2 14.5401 2.51508 15.457 3.43192C16.3738 4.34877 16.8889 5.59227 16.8889 6.88889C16.8889 8.1855 16.3738 9.42901 15.457 10.3459C14.5401 11.2627 13.2966 11.7778 12 11.7778C10.7034 11.7778 9.45988 11.2627 8.54303 10.3459C7.62619 9.42901 7.11111 8.1855 7.11111 6.88889ZM7.11111 14.2222C5.49034 14.2222 3.93596 14.8661 2.7899 16.0121C1.64385 17.1582 1 18.7126 1 20.3333C1 21.3058 1.38631 22.2384 2.07394 22.9261C2.76158 23.6137 3.69421 24 4.66667 24H19.3333C20.3058 24 21.2384 23.6137 21.9261 22.9261C22.6137 22.2384 23 21.3058 23 20.3333C23 18.7126 22.3562 17.1582 21.2101 16.0121C20.064 14.8661 18.5097 14.2222 16.8889 14.2222H7.11111Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.6e38a5ed3beb73c43f4aaa88a4ba3805.svg";
export { ForwardRef as ReactComponent };